// types
import {SaleProductParamActionTypes, SaleProductParamState, ProductParamType, ProductParamListValueType} from "./types";

export const NewSaleProductParamItem:ProductParamType = {
  enabled: true,
  name: '',
  order: 500
}
export const NewSaleProductParamListItem:ProductParamListValueType = {
  enabled: true,
  order: 500
}

export const INIT_STATE_SALE_PRODUCT_PARAM: SaleProductParamState = {
  items: [],
  rightModalShow: false,
  removeModalShow: false,
  selectedItem: NewSaleProductParamItem,
  modalEditTitle: '',
  isSending: false,
  isFetched: false,
  isLoading: false,
  isNeedReload: false
};

const SaleProductParam = (state = INIT_STATE_SALE_PRODUCT_PARAM, action: any) => {
  switch (action.type) {
    case SaleProductParamActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case SaleProductParamActionTypes.GET_PRODUCT_PARAMS:
          return {
            ...state,
            items: action.payload.data.items,
            meta: action.payload.data.meta,
            isFetched: true,
            isLoading: false,
            isNeedReload: false
          };
        case SaleProductParamActionTypes.UPDATE_PRODUCT_PARAM:
          return {
            ...state,
            selectedItem: NewSaleProductParamItem,
            rightModalShow: false,
            isSending: false,
            isNeedReload: true
          };
        case SaleProductParamActionTypes.REMOVE_PRODUCT_PARAM:
          return {
            ...state,
            selectedItem: NewSaleProductParamItem,
            removeModalShow: false,
            isNeedReload: true
          };
        default:
          return { ...state };
      }

    case SaleProductParamActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case SaleProductParamActionTypes.GET_PRODUCT_PARAMS:
          return {
            ...state,
            isFetched: false,
            isLoading: false,
            isNeedReload: false
          };
        case SaleProductParamActionTypes.UPDATE_PRODUCT_PARAM:
          return {
            ...state,
            isSending: false
          };
        case SaleProductParamActionTypes.REMOVE_PRODUCT_PARAM:
          return {
            ...state,
            removeModalShow: false
          };
        default:
          return { ...state };
      }
    case SaleProductParamActionTypes.EDIT_PRODUCT_PARAM:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case SaleProductParamActionTypes.RIGHT_MODAL_SHOW:
      return {
        ...state,
        selectedItem: NewSaleProductParamItem,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case SaleProductParamActionTypes.REMOVE_PRODUCT_PARAM_MODAL_SHOW:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        removeModalShow: true
      }
    case SaleProductParamActionTypes.REMOVE_PRODUCT_PARAM_MODAL_HIDE:
      return {
        ...state,
        selectedItem: NewSaleProductParamItem,
        removeModalShow: false
      }
    case SaleProductParamActionTypes.RIGHT_MODAL_HIDE:
      return {
        ...state,
        rightModalShow: false
      }
    case SaleProductParamActionTypes.UPDATE_PRODUCT_PARAM:
      return {
        ...state,
        isSending: true
      };
    case SaleProductParamActionTypes.GET_PRODUCT_PARAMS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return { ...state };
  }
};

export default SaleProductParam;
